import { CheckCircle2, RefreshCw } from "lucide-react";
import { cn } from "@/lib/utils/cn";
import { useSyncPoll } from "@/lib/query/useSyncPoll";
import { useSession } from "@/lib/store/session";
import { SimpleTooltip } from "@/components/ui/tooltip";

export function SyncChip({ className }: { className?: string }) {
  const loggedIn = useSession((s) => !!s.userId);
  const q = useSyncPoll();
  if (!loggedIn) return null;
  const syncing = q.isFetching;
  const label = syncing ? "Checking for new activities" : q.isError ? "Sync check failed" : "Up to date";
  return (
    <SimpleTooltip label={label}>
      <span
        role="status"
        aria-live="polite"
        className={cn(
          "inline-flex h-7 items-center gap-1.5 rounded-full border border-border bg-surface-2 px-2.5 text-xs font-medium text-fg-muted",
          q.isError && "text-warning",
          className,
        )}
      >
        {syncing ? <RefreshCw className="size-3.5 animate-spin" /> : <CheckCircle2 className={cn("size-3.5", !q.isError && "text-success")} />}
        <span className="hidden sm:inline">{syncing ? "Syncing" : q.isError ? "Offline" : "Synced"}</span>
      </span>
    </SimpleTooltip>
  );
}
